import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

export function useUrlParams<T>(): T {
    const [urlParams, setParams] = useState<T>({} as T);
    const location = useLocation();

    const parseParams = (params: string) => {
        return JSON.parse('{"' + params.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) { return key === '' ? value : decodeURIComponent(value); });
    };

    useEffect(() => {
        if (location.search !== '') {
            const params = parseParams(location.search.substring(1));
            setParams(params);
        }
    }, [location]);

    return urlParams;
}
